import useMutation from '@hooks/useGQLMutation'

import { scopedTranslation } from '@utils/I18n'
import { toast } from '@stores/toastStore'

import { RestoreRemovedAssigneeDocument } from '@frontend/graphql/mutations/restoreRemovedAssignee.generated'

const t = scopedTranslation('roster_board')

type RestoreRemovedAssigneeValues = {
  shiftId: string
  personId: string
  onSuccess: () => void
  onError?: () => void
}

const useRestoreRemovedAssigneeMutation = () => {
  const { mutate } = useMutation<typeof RestoreRemovedAssigneeDocument>(RestoreRemovedAssigneeDocument)

  return async ({ shiftId, personId, onSuccess, onError }: RestoreRemovedAssigneeValues) => {
    mutate(
      { input: { shiftId, personId } },
      {
        onSuccess: (response) => {
          const result = response?.restoreRemovedAssignee

          if (result?.success) {
            onSuccess()
            return
          }

          toast.warning(result?.errors?.[0]?.message ?? t('errors.restore_failed'))
          onError?.()
        },
        onError: () => {
          toast.error(t('errors.restore_failed'))
          onError?.()
        },
      }
    )
  }
}

export default useRestoreRemovedAssigneeMutation
